import {
  RailwayOrderStatus,
  SeatClass
} from '@link/china-railway/services/types';

export default {
  common: {
    colon: ': ',
    cancel: 'Cancel',
    confirm: 'Confirm'
  },
  date: {
    month: {
      month1: 'Jan',
      month2: 'Feb',
      month3: 'Mar',
      month4: 'Apr',
      month5: 'May',
      month6: 'Jun',
      month7: 'Jul',
      month8: 'Aug',
      month9: 'Sep',
      month10: 'Oct',
      month11: 'Nov',
      month12: 'Dec'
    },
    weeks: {
      sun: 'Sun.',
      mon: 'Mon.',
      tue: 'Tue.',
      wed: 'Wed.',
      thu: 'Thu.',
      fri: 'Fri.',
      sat: 'Sat.'
    }
  },
  seatClass: {
    [SeatClass.Business]: 'Business Class',
    [SeatClass.Premium]: 'Premium Class',
    [SeatClass.First]: 'First Class',
    [SeatClass.Second]: 'Second Class'
  },

  confirmBooking: {
    title: 'Notice',
    description:
      'Once confirmed, the booking cannot be changed. Please carefully verify the following information:',
    preOrderDescription:
      'After confirming the reservation, please check the ticket status on the [Order Details] page 15 days in advance. The result will not be sent via email or SMS.',
    departTime: 'Departure Time',
    trainNumber: 'Train Number',
    seatNumber: 'CAR./SEAT',
    autoAssign: 'Auto Assign',
    passengerName: 'Passenger Name',
    ticketCount: 'Ticket Count',
    confirmBook: 'Confirm Booking',
    date: '{{month}}-{{day}}',
    orderSuccess: 'Booking successful',
    orderFailed: 'Booking failed, please try again later'
  },
  views: {
    booking: {
      bookingId: 'Order {{id}}'
    },
    railway: {
      details: 'Order Details',
      booking: 'Book High-Speed Train',
      ticketCount: 'Ticket Count',
      selectDate: 'Select Travel Date',
      moreTime: 'More Times',
      bookTicket: 'Book Train',
      status: {
        [RailwayOrderStatus.StatusUnspecified]: 'Unknown Status',
        [RailwayOrderStatus.Reserved]: 'Booking in progress, please wait',
        [RailwayOrderStatus.Booked]: 'Booking in progress, please wait',
        [RailwayOrderStatus.Cancelling]: 'Cancelling',
        [RailwayOrderStatus.Cancelled]: 'Cancelled',
        [RailwayOrderStatus.Closed]: 'Insufficient tickets, please rebook',
        [RailwayOrderStatus.Issuing]: 'Booking in progress, please wait',
        [RailwayOrderStatus.Issued]: 'Booking successful, ticket issued',
        [RailwayOrderStatus.Used]: 'Used'
      },
      usageDate: 'Usage Date'
    },
    trainList: {
      book: 'Book',
      preBook: 'Pre-book',
      noTrains: 'No trains available for this time slot',
      hour: 'h',
      minute: 'min',
      durationFormat: '{{hours}}h {{minutes}}min',
      ticketsLeft: '{{count}} tickets left',
      noTickets: 'Tickets sold out',
      notOnSale: 'Not on sale yet'
    },
    orderDetail: {
      title: 'Order Details',
      faq: 'FAQ',
      dateTimeFormat: '{{year}}/{{month}}/{{day}} {{time}}',
      travelInfo: 'Travel Information',
      departureTime: 'Departure Time',
      trainNumber: 'Train Number',
      seatNumber: 'CAR./SEAT',
      passengerName: 'Passenger Name',
      ticketCount: 'Ticket Count',
      highSpeedTicket: 'High-Speed Train Ticket',
      orderId: 'Order ID',
      orderTime: 'Order Completion Time',
      rebookTicket: 'Rebook Ticket',
      preOrderStatus: 'Reserved, on sale in {{days}} days',
      saleDate: 'Sale Date',
      saleDateFormat: '{{year}}/{{month}}/{{day}}',
      cancelOrder: 'Cancel Order',
      cancelOrderSuccess: 'Order cancelled successfully',
      cancelOrderFailed: 'Failed to cancel order, please try again later',
      cancelOrderDialog: {
        title: 'Cancel Order',
        content: 'You can rebook after cancellation',
        confirm: 'Confirm Cancel',
        cancel: 'Keep Order'
      }
    }
  }
};
